import { render } from "./VerifyPayment.vue?vue&type=template&id=63acb6c0"
import script from "./VerifyPayment.vue?vue&type=script&lang=js"
export * from "./VerifyPayment.vue?vue&type=script&lang=js"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__